import { BANNER_ID, PREFS_ID, OVERLAY_ID, STYLES_ID, COOKIE_ICON_ID } from './constants';
import { storeConsent, getStoredConsent, clearStoredConsent } from './consent';
import { sendCookieBannerAnalytics } from './analyticsSend';
import { buildCSS } from './styles';
import { buildBannerHTML, buildPreferencesHTML, buildCookieSettingsHTML } from './html';
import { getRegionStateSync } from './region';
import {
  cookieIcon3dDefsHtml,
  cookieIcon3dFillUrl,
  cookieIcon3dFilterUrl,
} from './cookieIcon3dSvg';
import {
  COOKIE_ICON_GALLERY,
  buildGalleryIconHtml,
} from './cookieIconGallery';
import { clampCookieIconShadow } from './cookieIcon3dButton';

let currentPrefs = { statistics: false, marketing: false, preferences: false };

function buildCookieIconSvgs(amount = 100) {
  const defs = (suffix) => cookieIcon3dDefsHtml(suffix, amount);
  return {
  cookie:
    '<svg viewBox="-40 -40 592 592" overflow="visible" aria-hidden="true" focusable="false" style="color:inherit;display:block;margin:0 auto">' +
    defs('cookie') +
    '<g transform="translate(-9 -7)">' +
    '<path fill="' + cookieIcon3dFillUrl('cookie') + '" fill-rule="evenodd" filter="' + cookieIcon3dFilterUrl('cookie') + '" d="M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"/>' +
    '<path fill="none" stroke="currentColor" stroke-width="1.5" vector-effect="non-scaling-stroke" stroke-linejoin="round" stroke-linecap="round" fill-rule="evenodd" d="M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"/>' +
    '</g></svg>',
  'cookie-bite':
    '<svg viewBox="-2.2 -2.2 28.4 28.4" fill="none" overflow="visible" aria-hidden="true" focusable="false" style="color:inherit">' +
    defs('cookie-bite') +
    '<g transform="translate(12 12) scale(1.18) translate(-12 -12)" filter="' + cookieIcon3dFilterUrl('cookie-bite') + '">' +
    '<path d="M12.1521 4.08723C12.1513 3.71959 12.1001 3.3538 12 3C16.9683 3.00545 20.9944 7.03979 21 12C21.0161 16.9625 16.9705 20.9835 12 20.9997C7.02946 21.0158 3.01615 16.963 3 12.0005C4.11168 12.2363 5.27038 11.9981 6.1499 11.2795C7.0562 10.5452 7.5789 9.43935 7.5702 8.27407C7.56959 8.01195 7.5461 7.75072 7.5 7.49268C8.51784 7.89624 9.67043 7.76409 10.5708 7.14162C11.5696 6.44537 12.161 5.3034 12.1521 4.08723Z" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M3.00195 7.002V7H3V7.00195L3.00195 7.002Z" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M8.00195 3.002V3H8V3.00195L8.00195 3.002Z" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M4.00195 3.002V3H4V3.00195L4.00195 3.002Z" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M10.002 17.002V17H10V17.002L10.002 17.002Z" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M15.002 15.002V15H15V15.002L15.002 15.002Z" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M11.002 12.002V12H11V12.002L11.002 12.002Z" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M16.002 10.002V10H16V10.002L16.002 10.002Z" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</g></svg>',
  shield:
    '<svg viewBox="-1.5 -1.5 19 19" fill="none" overflow="visible" aria-hidden="true" focusable="false" style="color:inherit">' +
    defs('shield') +
    '<g transform="translate(8 8) scale(1.18) translate(-8 -8)" filter="' + cookieIcon3dFilterUrl('shield') + '">' +
    '<path fill="' + cookieIcon3dFillUrl('shield') + '" fill-rule="evenodd" clip-rule="evenodd" d="M8 16L4.35009 13.3929C2.24773 11.8912 1 9.46667 1 6.88306V3L8 0L15 3V6.88306C15 9.46667 13.7523 11.8912 11.6499 13.3929L8 16ZM12.2071 5.70711L10.7929 4.29289L7 8.08579L5.20711 6.29289L3.79289 7.70711L7 10.9142L12.2071 5.70711Z"/>' +
    '</g></svg>',
  settings:
    '<svg viewBox="-2.2 -2.2 28.4 28.4" overflow="visible" aria-hidden="true" focusable="false" style="color:inherit">' +
    defs('settings') +
    '<g transform="translate(12 12) scale(1.18) translate(-12 -12)" filter="' + cookieIcon3dFilterUrl('settings') + '">' +
    '<path fill="' + cookieIcon3dFillUrl('settings') + '" d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.6-.22l-2.39.96a7.07 7.07 0 0 0-1.63-.94l-.36-2.54a.5.5 0 0 0-.5-.42h-3.84a.5.5 0 0 0-.5.42l-.36 2.54c-.59.24-1.13.55-1.63.94l-2.39-.96a.5.5 0 0 0-.6.22L2.71 8.84a.5.5 0 0 0 .12.64l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94L2.83 14.52a.5.5 0 0 0-.12.64l1.92 3.32c.12.22.37.3.6.22l2.39-.96c.5.39 1.04.7 1.63.94l.36 2.54c.05.24.26.42.5.42h3.84c.24 0 .45-.18.5-.42l.36-2.54c.59-.24 1.13-.55 1.63-.94l2.39.96c.23.08.48 0 .6-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58zM12 15.5A3.5 3.5 0 1 1 12 8.5a3.5 3.5 0 0 1 0 7z"/>' +
    '</g></svg>',
  // Edge “side button” — chevron points inward from the docked edge.
  side:
    '<svg viewBox="-2.2 -2.2 28.4 28.4" overflow="visible" aria-hidden="true" focusable="false" style="color:inherit">' +
    defs('side') +
    '<g transform="translate(12 12) scale(1.18) translate(-12 -12)" filter="' + cookieIcon3dFilterUrl('side') + '">' +
    '<path fill="' + cookieIcon3dFillUrl('side') + '" d="M14.86 8.15a.75.75 0 0 1 0 1.06L11.21 12.5l3.65 3.65a.75.75 0 1 1-1.06 1.06l-4.18-4.18a.75.75 0 0 1 0-1.06l4.18-4.18a.75.75 0 0 1 1.06 0z"/>' +
    '</g></svg>',
  'side-right':
    '<svg viewBox="-2.2 -2.2 28.4 28.4" overflow="visible" aria-hidden="true" focusable="false" style="color:inherit">' +
    defs('side-right') +
    '<g transform="translate(12 12) scale(1.18) translate(-12 -12)" filter="' + cookieIcon3dFilterUrl('side-right') + '">' +
    '<path fill="' + cookieIcon3dFillUrl('side-right') + '" d="M9.14 8.15a.75.75 0 0 1 1.06 0l4.18 4.18a.75.75 0 0 1 0 1.06l-4.18 4.18a.75.75 0 1 1-1.06-1.06L12.79 12.5 9.14 8.85a.75.75 0 0 1 0-1.06z"/>' +
    '</g></svg>',
  ...Object.fromEntries(
    COOKIE_ICON_GALLERY.map((item) => [
      item.value,
      buildGalleryIconHtml(item, defs, cookieIcon3dFillUrl, cookieIcon3dFilterUrl),
    ]),
  ),
  };
}

function resolveCookieIconStyle(config) {
  const raw = config.cookie_icon_style || 'cookie-vector';
  const style =
    raw === 'side' || raw === 'side-right' ? 'cookie-vector' : raw;
  const known = {
    cookie: true,
    'cookie-bite': true,
    shield: true,
    settings: true,
    side: true,
    'side-right': true,
  };
  for (let i = 0; i < COOKIE_ICON_GALLERY.length; i++) {
    known[COOKIE_ICON_GALLERY[i].value] = true;
  }
  return known[style] ? style : 'cookie-vector';
}

function resolveCookieIconSize(config) {
  const size = config.cookie_icon_size || 'medium';
  return size === 'small' || size === 'large' ? size : 'medium';
}

function resolveCookieIconPosition(config) {
  const pos = config.cookie_icon_position || 'bottom-left';
  const allowed = {
    'bottom-left': 1,
    'bottom-right': 1,
    'top-left': 1,
    'top-right': 1,
  };
  let resolved = allowed[pos] ? pos : 'bottom-left';
  // Text re-open button always docks to the bottom.
  if (resolveCookieIconDisplay(config) === 'text' && resolved.startsWith('top-')) {
    resolved = resolved.includes('right') ? 'bottom-right' : 'bottom-left';
  }
  return resolved;
}

function resolveCookieIconDisplay(config) {
  return config.cookie_icon_display === 'text' ? 'text' : 'icon';
}

function resolveCookieIconReopenText(config) {
  const text = String(config.cookie_icon_reopen_text || 'Manage cookie').trim();
  return text || 'Manage cookie';
}

function isStrictRegion() {
  const s = getRegionStateSync();
  return !!(s && s.isStrict);
}

const FOCUSABLE_SELECTOR =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

function getFocusableElements(root) {
  if (!root) return [];
  return Array.from(root.querySelectorAll(FOCUSABLE_SELECTOR))
    .filter(el => !el.disabled && el.offsetParent !== null);
}

/**
 * Install a focus trap + optional Escape-to-close on a dialog element.
 * Returns a teardown function that should be called when the dialog closes;
 * also restores focus to the previously-focused element.
 */
function installDialogA11y(dialog, { allowEscape, onEscape }) {
  const previousFocus = document.activeElement;

  const onKeydown = e => {
    if (e.key === 'Escape' && allowEscape) {
      e.preventDefault();
      if (typeof onEscape === 'function') onEscape();
      return;
    }
    if (e.key !== 'Tab') return;
    const focusables = getFocusableElements(dialog);
    if (!focusables.length) {
      e.preventDefault();
      return;
    }
    const first = focusables[0];
    const last  = focusables[focusables.length - 1];
    const active = document.activeElement;
    if (e.shiftKey) {
      if (active === first || !dialog.contains(active)) {
        e.preventDefault();
        last.focus();
      }
    } else if (active === last) {
      e.preventDefault();
      first.focus();
    }
  };

  dialog.addEventListener('keydown', onKeydown);

  return function teardown() {
    dialog.removeEventListener('keydown', onKeydown);
    try {
      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    } catch (_) {}
  };
}

let bannerTeardown = null;
let prefsTeardown  = null;
/** Removes document-level implied-consent listener; set only when that mode is active. */
let impliedOutsideClickCleanup = null;

function teardownImpliedOutsideClick() {
  if (typeof impliedOutsideClickCleanup === 'function') {
    impliedOutsideClickCleanup();
    impliedOutsideClickCleanup = null;
  }
}

function closestAction(el) {
  while (el) {
    if (el.getAttribute && el.getAttribute('data-acb-action')) return el;
    el = el.parentNode;
  }
  return null;
}

function resolvePosition(config) {
  const layout = config.layout   || 'banner';
  const pos    = config.position || 'bottom';
  if (layout === 'dialog') return 'center';
  if (layout === 'box')    return pos === 'left' ? 'left' : 'right';
  return pos === 'top' ? 'top' : 'bottom';
}

export function injectStyles(config) {
  const css = buildCSS(config, BANNER_ID, PREFS_ID, OVERLAY_ID, COOKIE_ICON_ID);
  const existing = document.getElementById(STYLES_ID);
  if (existing) {
    if (existing.textContent !== css) existing.textContent = css;
    return;
  }
  const el = document.createElement('style');
  el.id          = STYLES_ID;
  el.textContent = css;
  document.head.appendChild(el);
}

export function showCookieIcon(config) {
  if (!config || !config.cookie_icon_enabled) return;
  if (document.getElementById(COOKIE_ICON_ID)) return;

  injectStyles(config);

  const display = resolveCookieIconDisplay(config);
  const style = resolveCookieIconStyle(config);
  const size = resolveCookieIconSize(config);
  const reopenText = resolveCookieIconReopenText(config);
  const btn = document.createElement('button');
  btn.id = COOKIE_ICON_ID;
  btn.type = 'button';
  btn.className =
    `acb-cookie-icon-pos-${resolveCookieIconPosition(config)} ` +
    `acb-cookie-icon-size-${size}` +
    (display === 'text' ? ' acb-cookie-icon-display-text' : '') +
    (display !== 'text' && style === 'cookie' ? ' acb-cookie-icon-style-cookie' : '');
  btn.setAttribute('aria-label', display === 'text' ? reopenText : 'Cookie preferences');
  if (display === 'text') {
    btn.textContent = reopenText;
  } else {
    const shadowAmount = clampCookieIconShadow(config.cookie_icon_shadow);
    btn.innerHTML = buildCookieIconSvgs(shadowAmount)[style];
  }
  btn.addEventListener('click', () => {
    openCookieSettings(config);
  });
  document.body.appendChild(btn);
}

/**
 * Toggle the icon-anchored cookie settings panel — never the centered popup.
 * Shared by the floating icon and merchant-supplied trigger elements.
 */
export function openCookieSettings(config) {
  if (!config) return false;
  if (document.getElementById(PREFS_ID)) {
    closePreferences();
    return true;
  }
  sendCookieBannerAnalytics('open_preferences');
  showPreferences(config, { mode: 'icon' });
  return true;
}

export function showBanner(config) {
  injectStyles(config);

  const layout = config.layout || 'banner';
  const pos    = resolvePosition(config);

  const banner = document.createElement('div');
  banner.id        = BANNER_ID;
  banner.className = `acb-layout-${layout} acb-pos-${pos}`;
  banner.setAttribute('role',       'dialog');
  banner.setAttribute('aria-label', 'Cookie consent');
  banner.setAttribute('aria-modal', 'true');
  // Focus the dialog surface (not Reject) so opening the banner does not
  // paint a browser focus ring on the first action button.
  banner.setAttribute('tabindex', '-1');
  banner.innerHTML = buildBannerHTML(config, isStrictRegion());
  document.body.appendChild(banner);

  if (config.force_banner_interaction) {
    const overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    document.body.insertBefore(overlay, banner);
  }

  // Escape closes the banner only when interaction is NOT forced — forcing
  // interaction usually means the merchant requires an explicit choice.
  bannerTeardown = installDialogA11y(banner, {
    allowEscape: !config.force_banner_interaction,
    onEscape:    closeBanner,
  });

  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      banner.classList.add('acb-visible');
      try {
        banner.focus({ preventScroll: true });
      } catch (_) {
        banner.focus();
      }
    })
  );

  banner.addEventListener('click', e => {
    const target = closestAction(e.target);
    if (target) handleBannerAction(target.getAttribute('data-acb-action'), config);
  });

  // Implied consent: first click outside the banner (and outside preferences) records
  // consent and closes — same category semantics as notice dismiss (strict = deny optional).
  if (config.consent_type === 'implied' && !config.force_banner_interaction) {
    const onDocumentClickCapture = e => {
      if (!document.getElementById(BANNER_ID)) {
        teardownImpliedOutsideClick();
        return;
      }
      if (document.getElementById(PREFS_ID)) return;
      const t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      if (t.closest(`#${BANNER_ID}`) || t.closest(`#${PREFS_ID}`) || t.closest(`#${COOKIE_ICON_ID}`)) return;

      const accepted = !isStrictRegion();
      const consent = storeConsent(
        { statistics: accepted, marketing: accepted, preferences: accepted },
        'implied_consent',
      );
      sendCookieBannerAnalytics(accepted ? 'accept' : 'reject', consent);
      closeBanner();
    };
    impliedOutsideClickCleanup = () => {
      document.removeEventListener('click', onDocumentClickCapture, true);
    };
    document.addEventListener('click', onDocumentClickCapture, true);
  }
}

function handleBannerAction(action, config) {
  switch (action) {
    case 'accept': {
      const consent = storeConsent({ statistics: true,  marketing: true,  preferences: true  }, 'accept');
      sendCookieBannerAnalytics('accept', consent);
      closeBanner();
      break;
    }
    case 'reject': {
      const consent = storeConsent({ statistics: false, marketing: false, preferences: false }, 'reject');
      sendCookieBannerAnalytics('reject', consent);
      closeBanner();
      break;
    }
    case 'do_not_sell': {
      const consent = storeConsent({ statistics: false, marketing: false, preferences: false }, 'do_not_sell');
      sendCookieBannerAnalytics('do_not_sell', consent);
      closeBanner();
      break;
    }
    case 'dismiss': {
      // In strict regions a notice dismiss must NOT count as accept-all. The
      // engine still records the action for accountability but stores all
      // optional categories as denied. Outside strict regions we keep the
      // legacy notice-only "implied accept" behavior the merchant opted into.
      const accepted = !isStrictRegion();
      const consent = storeConsent(
        { statistics: accepted, marketing: accepted, preferences: accepted },
        'notice_dismissed',
      );
      sendCookieBannerAnalytics('dismiss', consent);
      closeBanner();
      break;
    }
    case 'preferences':
      sendCookieBannerAnalytics('open_preferences');
      showPreferences(config);
      break;
  }
}

function syncPrefsFromStored() {
  const stored = getStoredConsent();
  if (!stored || !stored.categories) return;
  currentPrefs = {
    statistics:  !!stored.categories.statistics,
    marketing:   !!stored.categories.marketing,
    preferences: !!stored.categories.preferences,
  };
}

function bindPreferencesActions(popup, config) {
  popup.addEventListener('change', e => {
    const cat = e.target.getAttribute('data-acb-cat');
    if (cat && cat in currentPrefs) currentPrefs[cat] = e.target.checked;
  });

  popup.addEventListener('click', e => {
    const target = closestAction(e.target);
    if (!target) return;
    const action = target.getAttribute('data-acb-action');
    if (action === 'accept_all') {
      currentPrefs = { statistics: true, marketing: true, preferences: true };
      const consent = storeConsent(currentPrefs, 'accept');
      sendCookieBannerAnalytics('accept_all', consent);
      closePreferences();
      closeBanner();
    } else if (action === 'reject_all') {
      currentPrefs = { statistics: false, marketing: false, preferences: false };
      const consent = storeConsent(currentPrefs, 'reject');
      sendCookieBannerAnalytics('reject_all', consent);
      closePreferences();
      closeBanner();
    } else if (action === 'save_prefs') {
      const consent = storeConsent(currentPrefs, 'preferences_saved');
      sendCookieBannerAnalytics('save_prefs', consent);
      closePreferences();
      closeBanner();
    } else if (action === 'close_prefs') {
      closePreferences();
    } else if (action === 'toggle_cat_desc') {
      const category = target.closest('.acb-category');
      if (!category) return;
      const details = category.querySelector('[data-acb-cat-desc]');
      if (!details) return;
      const collapsed = category.classList.toggle('acb-collapsed');
      target.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    }
  });
}

function bindCookieSettingsActions(popup, config) {
  popup.addEventListener('click', e => {
    const target = closestAction(e.target);
    if (!target) return;
    const action = target.getAttribute('data-acb-action');

    if (action === 'close_settings') {
      closePreferences();
      return;
    }

    if (action === 'toggle_details') {
      const details = popup.querySelector('[data-acb-details]');
      const label = popup.querySelector('.acb-settings-details-label');
      if (!details) return;
      const hidden = details.classList.toggle('acb-hidden');
      target.setAttribute('aria-expanded', hidden ? 'false' : 'true');
      target.classList.toggle('acb-collapsed', hidden);
      if (label) label.textContent = hidden ? 'Show details' : 'Hide details';
      return;
    }

    if (action === 'withdraw_consent') {
      clearStoredConsent();
      currentPrefs = { statistics: false, marketing: false, preferences: false };
      closePreferences();
      closeBanner();
      showBanner(config);
      showCookieIcon(config);
      return;
    }

    if (action === 'change_consent') {
      // Swap immediately so PREFS_ID is free for the unchanged preferences UI.
      closePreferences({ immediate: true });
      showPreferences(config, { mode: 'icon-prefs' });
    }
  });
}

export function showPreferences(config, options = {}) {
  if (document.getElementById(PREFS_ID)) return;

  injectStyles(config);
  syncPrefsFromStored();

  const rawMode = options && options.mode;
  // Icon click → status panel. Banner "Preferences" → center prefs (unchanged).
  // "Change consent" → anchored prefs (same markup/behavior as banner prefs).
  const mode =
    rawMode === 'icon' || rawMode === 'icon-prefs' ? rawMode : 'center';
  const isSettings = mode === 'icon';
  const isAnchored = mode === 'icon' || mode === 'icon-prefs';

  const popup = document.createElement('div');
  popup.id = PREFS_ID;
  if (isAnchored) {
    popup.className =
      `acb-prefs-anchored acb-prefs-pos-${resolveCookieIconPosition(config)}` +
      (isSettings ? ' acb-cookie-settings' : '');
  }
  popup.setAttribute('role', 'dialog');
  popup.setAttribute(
    'aria-label',
    isSettings ? 'Your cookie settings' : 'Cookie preferences',
  );
  popup.setAttribute('aria-modal', 'true');
  // Focus the dialog surface so opening prefs does not highlight a control.
  popup.setAttribute('tabindex', '-1');
  popup.innerHTML = isSettings
    ? buildCookieSettingsHTML(config, getStoredConsent())
    : buildPreferencesHTML(config, { anchored: isAnchored });
  document.body.appendChild(popup);

  if (!isSettings) {
    Object.keys(currentPrefs).forEach(key => {
      const input = popup.querySelector(`[data-acb-cat="${key}"]`);
      if (input) input.checked = currentPrefs[key];
    });
  }

  // Preferences dialog always allows Escape to close — there is no "forced
  // interaction" semantics for the secondary surface; the user can just go
  // back to the banner.
  prefsTeardown = installDialogA11y(popup, {
    allowEscape: true,
    onEscape:    closePreferences,
  });

  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      popup.classList.add('acb-visible');
      try {
        popup.focus({ preventScroll: true });
      } catch (_) {
        popup.focus();
      }
    })
  );

  if (isSettings) {
    bindCookieSettingsActions(popup, config);
  } else {
    bindPreferencesActions(popup, config);
  }
}

export function closeBanner() {
  teardownImpliedOutsideClick();
  const banner  = document.getElementById(BANNER_ID);
  const overlay = document.getElementById(OVERLAY_ID);
  if (banner) {
    banner.classList.remove('acb-visible');
    setTimeout(() => banner.parentNode?.removeChild(banner), 350);
  }
  if (overlay) {
    overlay.classList.add('acb-hiding');
    setTimeout(() => overlay.parentNode?.removeChild(overlay), 350);
  }
  if (typeof bannerTeardown === 'function') {
    bannerTeardown();
    bannerTeardown = null;
  }
}

function closePreferences(options = {}) {
  const el = document.getElementById(PREFS_ID);
  if (!el) return;
  const immediate = !!(options && options.immediate);
  if (typeof prefsTeardown === 'function') {
    prefsTeardown();
    prefsTeardown = null;
  }
  if (immediate) {
    el.parentNode?.removeChild(el);
    return;
  }
  el.classList.remove('acb-visible');
  setTimeout(() => el.parentNode?.removeChild(el), 350);
}
